import ErrorBoundary from 'components/ErrorBoundary'
import ReactStrapTable from 'components/reactStrapTable'
import React, { useState } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import ViewAuditToolTable from '../ViewAuditToolTable'
import Drawer from 'components/Drawer'

const GenerateAudit = () => {
    const [viewAudit , setViewAduit] = useState(false);

    const toggleViewAudit = () => {
        setViewAduit(!viewAudit);
      };
  return (
    <div>
                     <Container fluid className='my-3'>
                     <Card className='border-0 shadow-top'>
    <CardBody className='section-devider-border'>
        <ErrorBoundary>
            <Row>
                <h4 className='f-15 text-primary font-weight-700'>Audit Details </h4>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Audit Name :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"DSH390"}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Form Date :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"06-01-2024"}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">To Date :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"07-02-2024"}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Covered Entity :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"Covered Entity Name"}</p>

                </Col> 
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Covered Entity :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"Covered Entity Name"}</p>

                </Col> 
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Accmulator :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"Accumulator  Name"}</p>

                </Col> 
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Generarted Date :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"25-07-2024"}</p>

                </Col> 
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Aduit Count :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"25"}</p>

                </Col> 
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Account Type :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{"340B"}</p>

                </Col> 
               


            </Row>
         
            

        </ErrorBoundary>

    </CardBody>
    <CardBody className='section-devider-border'>
    <ViewAuditToolTable/>
    </CardBody>
    {/* <Drawer
        direction="end"
        title="340B Price Details"
        isOpen={viewAudit}
        toggle={toggleViewAudit}
        size="lg"
      >
      </Drawer> */}

</Card>


</Container>
    </div>
  )
}

export default GenerateAudit